import { render, staticRenderFns } from "./HotelAmenity.vue?vue&type=template&id=980eb1d2&"
import script from "./HotelAmenity.vue?vue&type=script&lang=js&"
export * from "./HotelAmenity.vue?vue&type=script&lang=js&"
import style0 from "./HotelAmenity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports